import { useCallback, useState } from 'react';
export const useResizableState = (state) => {
    const [displayState, setDisplayState] = useState(Array.from({ length: state }, () => true));
    const togglePanel = useCallback((index) => {
        setDisplayState((prev) => {
            const _new = [...prev];
            _new[index] = !prev[index];
            return _new;
        });
    }, [displayState]);
    return displayState.map((open, index) => ({
        open,
        toggle: () => togglePanel(index),
    }));
};
